// Function loadWoolLabPersistentSwatchDrawer loads the WoolLabPersistentSwatchDrawer class by dynamically importing the js on demand if needed

export function loadWoolLabPersistentSwatchDrawer($parentEl, isList = false) {

	return import(/* webpackChunkName: "wg-fabric-swatch-favourites-block-chunk" */ '../widgets/woolLabPersistentSwatchDrawer').then(wg => {

		const { WoolLabPersistentSwatchDrawer } = wg;

		let $wg = $parentEl.querySelector('[data-wg="WoolLabPersistentSwatchDrawer"]');

		if(!$wg) {
			// console.info('WoolLabPersistentSwatchDrawer: no widget found');
			return null;
		}

		if (isList) {
			let $wgCol = $parentEl.querySelectorAll('[data-wg="WoolLabPersistentSwatchDrawer"]');
			let instances = [];
			$wgCol.forEach(($wg, i) => {
				instances.push( new WoolLabPersistentSwatchDrawer($wg) );
			});
			if (instances.length === $wgCol.length) return instances;

		} else {
			return new WoolLabPersistentSwatchDrawer($wg);
		}


	}).catch(error => error+'An error occurred while loading the WoolLabPersistentSwatchDrawer widget');

}
